/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { CheckCircle2Icon } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const PieIcon = ({ percentage }: { percentage: number }) => {
  const size = 18;
  const center = size / 2;
  const radius = 7;

  if (percentage <= 0) {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          className="text-slate-300"
        />
      </svg>
    );
  }

  const clampedPct = Math.min(percentage, 100);
  const angle = (clampedPct / 100) * 360;
  const rad = ((angle - 90) * Math.PI) / 180;
  const x = center + radius * Math.cos(rad);
  const y = center + radius * Math.sin(rad);
  const largeArc = angle > 180 ? 1 : 0;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="text-slate-200"
      />
      <path
        d={`M ${center} ${center - radius} A ${radius} ${radius} 0 ${largeArc} 1 ${x} ${y} L ${center} ${center} Z`}
        fill="currentColor"
        className="text-primary-600"
      />
    </svg>
  );
};

export const SectionProgressIndicator = ({
  filled,
  graceNote,
  total,
}: {
  filled: number;
  graceNote?: string;
  total: number;
}) => {
  const percentage = total > 0 ? Math.round((filled / total) * 100) : 0;
  const isComplete = total > 0 && filled >= total;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="flex shrink-0 items-center">
            {isComplete ? (
              <CheckCircle2Icon className="h-[18px] w-[18px] text-green-600" />
            ) : (
              <PieIcon percentage={percentage} />
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="text-xs">
            {isComplete ? (
              "Complete!"
            ) : (
              <>
                {percentage}% complete ({filled}/{total} fields)
              </>
            )}
          </p>
          {graceNote && (
            <p className="mt-1 text-xs text-slate-400">{graceNote}</p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
